
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2068.987-1769.073a1.566 1.566 0 001.062-.54l7.417-7.345a2.551 2.551 0 00-1.746-.459h-13.718a2.171 2.171 0 00-1.53.423l7.456 7.384a1.543 1.543 0 001.059.537zm-9.28 5.077l6.076-6.014-6.076-6a2.759 2.759 0 00-.225 1.305v9.4a2.759 2.759 0 00.225 1.309zm2.521 1.414h13.717a2.244 2.244 0 001.548-.423l-6.193-6.13-.54.54a2.571 2.571 0 01-1.773.828 2.571 2.571 0 01-1.773-.828l-.549-.54-6.175 6.125a2.694 2.694 0 001.738.428zm16.032-1.422a2.941 2.941 0 00.207-1.3v-9.4a2.806 2.806 0 00-.216-1.287l-6.059 5.981z"}})])])
          )
        }
      }
    